export const Payeezy = function() {
    function e(e) {
        var t = {
            visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            mastercard: /^(5[1-5][0-9]{14}|2[2-7][0-9]{14})$/,
            amex: /^3[47][0-9]{13}$/,
            diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
            jcb: /^(?:2131|1800|35\d{3})\d{11}$/
        };
        for (var n in t) {
            if (t[n].test(e)) {
                return n
            }
        }
    }
    //
    // function t() {
    //     var e = [];
    //     var t = document.getElementsByTagName("input");
    //     var n = document.getElementsByTagName("select");
    //     for (i = 0; i < t.length; i++) {
    //         var r = t[i];
    //         var s = r.getAttribute("payeezy-data");
    //         if (s) {
    //             e[s] = r.value
    //         }
    //     }
    //     for (i = 0; i < n.length; i++) {
    //         var r = n[i];
    //         var s = r.getAttribute("payeezy-data");
    //         if (s) {
    //             e[s] = r.value
    //         }
    //     }
    //     console.log(e)
    //     return e
    // }
    return {
        createToken: function(e) {
            var n = "api-cert.payeezy.com";
            this["clientCallback"] = e;
            var i = 0;
            var s = {};
            var o = 0;
            var u = [];
            if (!this.apikey) {
                i = 400;
                u[o] = {
                    description: "Please set the API Key"
                };
                o++
            }
            if (!this.js_security_key) {
                i = 400;
                u[o] = {
                    description: "Please set the js_security_key"
                }
            }
            if (!this.ta_token) {
                i = 400;
                u[o] = {
                    description: "Please set the ta_token"
                }
            }
            if (!this.auth) {
                i = 400;
                u[o] = {
                    description: "Please set auth value"
                }
            }
            if (u.length > 0) {
                s["error"] = {
                    messages: u
                };
                e(i, s);
                return false
            }
            var a = "https://" + this.endPoint + "/v1/securitytokens?apikey=" + this.apikey + "&js_security_key=" + this.js_security_key + "&callback=Payeezy.callback&auth=" + this.auth + "&ta_token=" + this.ta_token + "&type=FDToken&credit_card.type=" + this.cardType + "&credit_card.cardholder_name=" + this.cardHolderName + "&credit_card.card_number=" + this.cardNumber + "&credit_card.exp_date=" + this.expiryMonth + this.expiryYear + "&credit_card.cvv=" + this.cvv
			var f = document.createElement("script");
            f.src = a;
            document.getElementsByTagName("head")[0].appendChild(f)
        },
        setApiKey: function(e) {
            this["apikey"] = e
        },
        setJs_Security_Key: function(e) {
            this["js_security_key"] = e
        },
        setTa_token: function(e) {
            this["ta_token"] = e
        },
        setAuth: function(e){
            this["auth"] = e
        },
		    setCurrency: function(e) {
            this["currency"] = e
        },
        callback: function(e) {
            this["clientCallback"](e.status, e.results)
        },
        setCardNumber: function(cardNumber) {
          this['cardNumber'] = cardNumber
        },
        setCVV: function(cvv) {
          this['cvv'] = cvv
        },
        setExpiryMonth: function(cardExpiryMonth) {
          this['expiryMonth'] = cardExpiryMonth
        },
        setExpiryYear: function(cardExpiryYear) {
          this['expiryYear'] = cardExpiryYear
        },
        setCardType: function(cardType) {
          this['cardType'] = cardType
        },
        setCurrency: function(currency) {
          this['currency'] = currency
        },
        setCardHolderName: function(name){
          this['cardHolderName'] = name
        },
        setEndpoint: function (endpoint) {
          this['endPoint'] = endpoint
        }
    }
}();



// WEBPACK FOOTER //
// ./src/payeezy_us_v5.1.js